"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _MetricRow = _interopRequireDefault(require("web/shared/telemetry/overview/MetricRow"));
var _SortableHeader = _interopRequireDefault(require("web/shared/telemetry/overview/SortableHeader"));
var _MetricsTableData = require("web/shared/telemetry/overview/MetricsTable.data.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* Every metric this product declares, with how it behaved over the window.
*
* Metrics that recorded nothing are listed too. That is deliberate and is the
* page's most useful habit: a metric that silently stopped recording looks
* exactly like one nobody calls, from a list that omits both.
*/
function MetricsTable(_ref) {
  let metrics = _ref.metrics,
    sortColumn = _ref.sortColumn,
    descending = _ref.descending,
    onSort = _ref.onSort;
  if (metrics.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "This product declares no metrics yet. Adding one is adding a file under server/telemetry/definitions/."
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.tableWrap)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.table)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SortableHeader.default, {
            label: "metric",
            column: "key",
            activeColumn: sortColumn,
            descending: descending,
            onSort: onSort,
            numeric: false
          }), _MetricsTableData.NUMERIC_COLUMNS.map(entry => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SortableHeader.default, {
            label: entry.label,
            column: entry.column,
            activeColumn: sortColumn,
            descending: descending,
            onSort: onSort,
            numeric: true
          }, entry.column))]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: metrics.map(metric => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MetricRow.default, {
          metric: metric
        }, metric.key))
      })]
    }))
  }));
}
var _default = exports.default = MetricsTable;